var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { init, track, Identify, identify, setSessionId, flush, } from '@amplitude/analytics-browser';
var BlockTypes = require('../blockly/blockTypes').BlockTypes;
var FIELD_SOUNDS_NAME = require('../blockly/constants').FIELD_SOUNDS_NAME;
var API_KEY_ENDPOINT = '/musiclab/analytics_key';
var blockFeatureList = [
    BlockTypes.FOR_LOOP,
    BlockTypes.REPEAT_SIMPLE2,
    'controls_repeat_ext',
    BlockTypes.PLAY_SOUNDS_TOGETHER,
    BlockTypes.PLAY_SOUNDS_SEQUENTIAL,
    'functions',
    BlockTypes.PLAY_REST_AT_CURRENT_LOCATION_SIMPLE2,
];
var triggerBlocks = [
    BlockTypes.TRIGGERED_AT,
    BlockTypes.TRIGGERED_AT_SIMPLE,
    BlockTypes.TRIGGERED_AT_SIMPLE2,
    BlockTypes.NEW_TRACK_ON_TRIGGER,
];
var functionBlocks = ['procedures_defnoreturn', 'procedures_callnoreturn'];
/**
 * An analytics reporter specifically used for the Music Lab prototype, which logs analytics
 * to Amplitude. For the more general Amplitude Analytics Reporter used across the application
 * outside of Music Lab, check {@link apps/src/lib/util/AnalyticsReporter}.
 */
var AnalyticsReporter = /** @class */ (function () {
    function AnalyticsReporter() {
        var _this = this;
        this.sessionInProgress = false;
        this.identifyObj = new Identify();
        this.sessionStartTime = -1;
        this.maxInstructionsSeen = 0;
        this.currentInstructionsPage = 0;
        this.soundsUsed = new Set();
        this.blockStats = {
            endingBlockCount: 0,
            endingTriggerBlockCount: 0,
            endingTriggerBlocksWithCode: 0,
            maxBlockCount: 0,
            maxTriggerBlockCount: 0,
            maxTriggerBlocksWithCode: 0,
        };
        this.featuresUsed = {};
        blockFeatureList.forEach(function (feature) {
            _this.featuresUsed[feature] = false;
        });
    }
    AnalyticsReporter.prototype.startSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Capture start time before making init call
                        this.sessionStartTime = Date.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.initialize()];
                    case 2:
                        _a.sent();
                        setSessionId(this.sessionStartTime);
                        this.log("Session start. Session ID: ".concat(this.sessionStartTime));
                        this.sessionInProgress = true;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        message = error_1 instanceof Error ? error_1.message : String(error_1);
                        console.log("[AMPLITUDE ANALYTICS] Did not initialize analytics reporter.  (".concat(message, ")"));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AnalyticsReporter.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, responseJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(API_KEY_ENDPOINT)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        responseJson = _a.sent();
                        if (!responseJson.key) {
                            throw new Error('No key for analytics.');
                        }
                        return [2 /*return*/, init(responseJson.key, undefined, { minIdLength: 1 }).promise];
                }
            });
        });
    };
    AnalyticsReporter.prototype.setUserProperties = function (userId, userType, signInState) {
        if (!this.sessionInProgress) {
            this.log('No session in progress');
            return;
        }
        // Temporarily disabled, pending user privacy compliance discussions.
        // if (userId) {
        //   setUserId(hashString(userId));
        // }
        this.identifyObj.set('userType', userType);
        this.identifyObj.set('signInState', signInState);
        this.log("User properties: userId: ".concat(userId, ", userType: ").concat(userType, ", signInState: ").concat(signInState));
    };
    AnalyticsReporter.prototype.onButtonClicked = function (buttonName, properties) {
        this.trackUIEvent('Button clicked', __assign({ buttonName: buttonName }, properties));
    };
    AnalyticsReporter.prototype.onKeyPressed = function (keyName, properties) {
        this.trackUIEvent('Key pressed', __assign({ keyName: keyName }, properties));
    };
    AnalyticsReporter.prototype.trackUIEvent = function (eventType, payload) {
        var logMessage = "".concat(eventType, ". Payload: ").concat(JSON.stringify(payload));
        if (!this.sessionInProgress) {
            this.log("No session in progress.  (".concat(logMessage, ")"));
            return;
        }
        else {
            this.log(logMessage);
        }
        track(eventType, payload).promise;
    };
    AnalyticsReporter.prototype.onVideoClosed = function (id, duration) {
        var logMessage = "Video closed. Id: ".concat(id, ". Duration: ").concat(duration, "}");
        if (!this.sessionInProgress) {
            this.log("No session in progress.  (".concat(logMessage, ")"));
            return;
        }
        else {
            this.log(logMessage);
        }
        track('Video closed', { id: id, duration: duration }).promise;
    };
    AnalyticsReporter.prototype.onInstructionsVisited = function (page) {
        if (!this.sessionInProgress) {
            this.log('No session in progress');
            return;
        }
        this.currentInstructionsPage = page;
        this.maxInstructionsSeen = Math.max(this.maxInstructionsSeen, page);
    };
    AnalyticsReporter.prototype.onBlocksUpdated = function (blocks) {
        var _this = this;
        if (!this.sessionInProgress) {
            this.log('No session in progress');
            return;
        }
        var totalBlockCount = blocks.length;
        var triggerBlocksCount = 0;
        var triggerBlocksWithCode = 0;
        blocks.forEach(function (block) {
            if (triggerBlocks.includes(block.type)) {
                triggerBlocksCount++;
                if (block.getChildren(false).length > 0) {
                    triggerBlocksWithCode++;
                }
            }
            if (blockFeatureList.includes(block.type)) {
                _this.featuresUsed[block.type] = true;
            }
            if (functionBlocks.includes(block.type)) {
                _this.featuresUsed.functions = true;
            }
            if (block.getField(FIELD_SOUNDS_NAME)) {
                _this.soundsUsed.add(block.getFieldValue(FIELD_SOUNDS_NAME));
            }
        });
        this.blockStats = {
            endingBlockCount: totalBlockCount,
            endingTriggerBlockCount: triggerBlocksCount,
            endingTriggerBlocksWithCode: triggerBlocksWithCode,
            maxBlockCount: Math.max(this.blockStats.maxBlockCount, totalBlockCount),
            maxTriggerBlockCount: Math.max(this.blockStats.maxTriggerBlockCount, triggerBlocksCount),
            maxTriggerBlocksWithCode: Math.max(this.blockStats.maxTriggerBlocksWithCode, triggerBlocksWithCode),
        };
    };
    AnalyticsReporter.prototype.endSession = function () {
        if (!this.sessionInProgress) {
            this.log('No session in progress');
            return;
        }
        var duration = Date.now() - this.sessionStartTime;
        this.sessionStartTime = -1;
        this.sessionInProgress = false;
        identify(this.identifyObj);
        var payload = {
            durationSeconds: duration / 1000,
            mostInstructionsVisited: this.maxInstructionsSeen,
            lastInstructionsVisited: this.currentInstructionsPage,
            soundsUsed: Array.from(this.soundsUsed),
            blockStats: this.blockStats,
            featuresUsed: this.featuresUsed,
        };
        track('Session end', payload);
        flush();
        this.log("Session end. Payload: ".concat(JSON.stringify(payload)));
    };
    AnalyticsReporter.prototype.log = function (message) {
        console.log("[AMPLITUDE ANALYTICS EVENT]: ".concat(message));
    };
    return AnalyticsReporter;
}());
export default AnalyticsReporter;
